import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {noFiltersSelectorMonitoring, resetFiltersSliceMonitoring} from "../Selectors/filtersSliceMonitoring";

/** хук сбрасывает в `filterSlice` все данные на начальные */
export const useResetFiltersMonitoring = () => {
    const dispatch = useDispatch();
    const disabledReset = useSelector(noFiltersSelectorMonitoring);

    const onClickReset = React.useCallback(() => {
        dispatch(resetFiltersSliceMonitoring());
    }, [dispatch]);
    return { disabledReset, onClickReset };
};